import { render, staticRenderFns } from "./EventLiveCurtainButton.vue?vue&type=template&id=0d4d939e&scoped=true&"
import script from "./EventLiveCurtainButton.vue?vue&type=script&lang=js&"
export * from "./EventLiveCurtainButton.vue?vue&type=script&lang=js&"
import style0 from "./EventLiveCurtainButton.vue?vue&type=style&index=0&id=0d4d939e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4d939e",
  null
  
)

export default component.exports